import { fitBounds } from 'google-map-react'
import {
  getMarketsByBounds,
  getMarketsByLocation,
  getBoundsForMarkets
} from '../'

const GATSBY_MARKETSEARCH_MIN_RESULTS = 5
const GATSBY_MARKETSEARCH_MAX_DISTANCE_KM = 80

export const getMapStateAndMarketsForLocation = async (
  location,
  token,
  mapState
) => {
  const { result: marketsByLocation } = await getMarketsByLocation(
    location,
    GATSBY_MARKETSEARCH_MAX_DISTANCE_KM,
    GATSBY_MARKETSEARCH_MIN_RESULTS,
    token
  )

  const marketsBounds = getBoundsForMarkets(
    marketsByLocation,
    location,
    GATSBY_MARKETSEARCH_MIN_RESULTS,
    20
  )

  const { zoom, center } = fitBounds(marketsBounds, mapState.size)

  const { result: marketsByBounds } = await getMarketsByBounds(
    marketsBounds,
    location,
    token
  )

  return {
    mapState: { ...mapState, center, zoom, location, marketsBounds },
    markets: marketsByBounds
  }
}
